import { Button } from '@curri/components'

import { useAuth } from '../auth/AuthProvider.tsx'
import type { Section } from '../shell/destinations.ts'

// Placeholder for destinations the rail advertises but that are not built yet.
//
// Every advertised screen is now built, so nothing lands here for that reason
// any more. What still routes here is the shell's sign-in gate: an authenticated
// section a signed-out visitor asked for.

export const Placeholder = ({ section }: { section: Section }) => {
  const { state, signIn } = useAuth()
  // A failed sign-in is reported by the shell's toast, not here — the
  // redirect can land on any route, so the message has to live in the chrome.
  const needsSignIn = section.authenticated && state.status !== 'authenticated'

  return (
    <div style={{ maxWidth: 620, margin: '0 auto', padding: '64px 32px' }}>
      <h1 style={{ fontSize: 28 }}>{section.label}</h1>
      <p
        style={{
          margin: '12px 0 0',
          fontSize: 15,
          lineHeight: 1.6,
          color: 'var(--curri-text-secondary)',
        }}
      >
        {needsSignIn
          ? 'Sign in to see this page.'
          : 'This page is not built yet.'}
      </p>

      {needsSignIn && (
        <div style={{ marginTop: 20 }}>
          <Button label="Sign in" onClick={signIn} size="base" variant="brand" />
        </div>
      )}
    </div>
  )
}
